import { useEffect } from "react";

export default function useLiveClock(
  nextWakeAt: number | null,
  setNow: (at: number) => void,
): void {
  useEffect(() => {
    if (nextWakeAt === null) return undefined;
    const id = setTimeout(
      // Never earlier than nextWakeAt: an early timer must still make progress.
      () => setNow(Math.max(Date.now(), nextWakeAt)),
      Math.max(0, nextWakeAt - Date.now()),
    );
    return () => clearTimeout(id);
  }, [nextWakeAt, setNow]);
}
